import React from 'react';
import IconSvg from '@mdigital/components/dist/components/IconSvg';
import icon from '../../assets/actions/info.svg';
import {
  StyledBannerContainer,
  StyledBannerText
} from '../EnablementFormNotification/StyledEnablementFormNotification';
import { getSingleText } from '../../../common/utils';
import { StyledLink } from './StyledDeprecationBanner';

const DEPRECATION_DOCS_URL =
	'https://docs.medallia.com/en/medallia-digital-feedback/medallia-digital-feedback/administration-guide/migrate-to-medallia-experience-cloud-integration-version-2#functional-differences-0';

export default function DeprecationBanner() {
  return (
    <StyledBannerContainer data-aut="deprecation-banner">
      <IconSvg icon={icon} color={'#2E78D0'} width={18} height={18}/>
      <StyledBannerText>
        {getSingleText('app.deprecationBanner.message')}
      </StyledBannerText>
      <StyledLink href={DEPRECATION_DOCS_URL} target={'_blank'} data-aut="deprecation-banner-link">  {getSingleText('app.deprecationBanner.docsLinkLabel')} </StyledLink>
      <StyledBannerText>
        {getSingleText('app.deprecationBanner.message2')}
      </StyledBannerText>
    </StyledBannerContainer>
  );
}

const DEPRECATED_STATE_PREFIXES = [
  'app.pages.dashboard',
  'app.pages.messages',
  'app.pages.reports',
  'app.pages.actions.autoForward',
  'app.pages.smartReply',
  'app.pages.userManagement'
];

export function isDeprecatedState(stateName) {
  if (!stateName) {
    return false;
  }
  return DEPRECATED_STATE_PREFIXES.some(
    (prefix) => stateName === prefix || stateName.startsWith(prefix + '.')
  );
}
